import AdCreative from './AdCreative';
import './App.css';

function VirtualTabletScreen({
    campaign,
    height,
    width,
}) {
    return (
        <div
            style={{
                width: width,
                height: height,
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                backgroundColor: 'black',
                borderRadius: '0.4em',
            }}
        >
            <AdCreative
                creativeURL={campaign.creative_url}
                creativeExt={campaign.creative_ext}
                width='100%'
                height='100%'
                objectFit='contain'
            />
        </div>
    );
}

export default VirtualTabletScreen;